
export enum ReportCreationStatus {
  Pending = 0,
  Created = 1,
  Canceled = 2,
  Deleted = 3,
  ErrorOnCreation = 4
}
